exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button_from_Button-css_3cT {\r\n\r\n}\r\n\r\n.box_from_Button-css_FQo {\r\n  width: 100%;\r\n  padding: 24px;\r\n  display: table-cell;\r\n}\r\n\r\n.action_from_Button-css_24G {\r\n\r\n}\r\n\r\n.icon_from_Button-css_2AF {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin: 0 4px 0 4px;\r\n}\r\n\r\n.children_from_Button-css_2Oo {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin: 0 4px 0 4px;\r\n}\r\n\r\n.important_from_Button-css_3Uo {\r\n\r\n}\r\n", ""]);

// exports
exports.locals = {
	"button": "button_from_Button-css_3cT",
	"box": "box_from_Button-css_FQo",
	"action": "action_from_Button-css_24G",
	"icon": "icon_from_Button-css_2AF",
	"children": "children_from_Button-css_2Oo",
	"important": "important_from_Button-css_3Uo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/action/Button.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Button.css
// module chunks = 0